import React, { useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { label: 'Home', target: 'home' },
    { label: 'About us', target: 'about' },
    { label: 'Our services', target: 'services' },
    { label: 'Why Choose us', target: 'why' },
    { label: 'Projects', target: 'work' },
    { label: 'Locate', target: 'map' },
    { label: 'Contact us', target: 'contact' },
  ];
  

  return (
    <nav className="py-2 h-[90px] w-full shadow-md bg-white fixed top-0 left-0 z-50">
      <div className="px-4 md:px-20 grid grid-cols-[auto_1fr] items-center h-full">
       
<div className="flex items-center" style={{ width: '141px', height: '40px' }}>
  <img
    src="/Logo2.png"
    width="141"
    height="40"
    alt="Ram Engineer"
    className="object-contain"
  />
</div>
        <ul className="hidden md:flex items-center justify-end gap-6 text-sm font-medium">
        {navItems.map((item) => (
  <li
    key={item.target}
    className="hover:text-gray-600 transition-colors cursor-pointer"
    onClick={() => {
      document.getElementById(item.target)?.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false); // close mobile menu if open
    }}
  >
    {item.label}
  </li>
))}

        </ul>

        <button
          className="md:hidden justify-self-end text-2xl"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {menuOpen && (
        <ul className="md:hidden flex flex-col px-6 py-4 bg-white shadow-md space-y-4 text-sm font-medium">
          {navItems.map((item) => (
            <li key={item} className="border-b pb-2 cursor-pointer hover:text-grey-600"
            onClick={() => {
              document.getElementById(item.target)?.scrollIntoView({ behavior: 'smooth' });
              setMenuOpen(false); // close mobile menu if open
            }}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
